import Container from '@/shared/Container';
import Div from '@/shared/Div';
import React, { memo } from 'react';
import SharedStaticContent from '../Static/Shared/SharedStaticContent';

type SEOConentProps = {
  content: string;
};

function SEOConent(props: SEOConentProps) {
  return (
    <Div className="py-s8 text-cti-primary">
      <SharedStaticContent content={props.content} />
    </Div>
  );
}

export default memo(SEOConent);
